import React from 'react';
import CachedImg from 'src/components/10-atoms/image/CachedImg';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import ThumbnailContainer from './ThumbnailContainer';
const ImageThumbnail = ({ src, ...thumbnailContainerProps }) => {
    const [{ styles }] = useTheme(stylesGenerator);
    return (React.createElement(ThumbnailContainer, { src: src, ...thumbnailContainerProps },
        React.createElement(CachedImg, { style: styles.img, src: src })));
};
const stylesGenerator = createThemedStyle(({}) => ({
    img: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
}));
export default ImageThumbnail;
